export default {
  cancelUnpaidCheckout: "Cancelar",
  changeSelection: "Cambiar mi selección",
  packIncludesBoost:
    "Incluye el boost de {{count}} días, que pone tu anuncio en lo más alto de su categoría.",
  cartHeading: "Revisa tus servicios",
  cartLead: "Todos los servicios mostrados se incluyen en un único pago.",
  existingPayment:
    "Hay un pago pendiente. Revisa sus conceptos originales antes de volver a pagar.",
  resumePackagePayment: "Revisar el pago pendiente",
  emptyCart: "No hay servicios seleccionados.",
  removeItem: "Eliminar",
  currentCart: "Selección actual",
  reviewCartChanged:
    "La selección ha cambiado. Revisa los conceptos y acepta de nuevo las condiciones.",
  quoteExpiredCart:
    "Este presupuesto de promoción ha caducado. Vuelve a elegirla desde tu anuncio.",
  chooseAgain: "Volver a elegir",
  contextCreateAd: "Precio para un anuncio nuevo",
  contextMyAds: "Precio desde Mis anuncios",
  paymentOriginal: "Pago original",
  viewCart: "Revisar servicios seleccionados",

  continueToCart: "Continuar al pago conjunto",
  bankRateNote: "Pagas en euros. Tu banco aplica su propio tipo de cambio.",
  reverseVat: "Inversión del sujeto pasivo del IVA · pago único",
  checkout: "Continuar al pago",
  resumePayment: "Reanudar el pago",
  storeReceipt: "Consulta el recibo de la tienda",
  title: "Dale más visibilidad a tu anuncio",
  lead: "Elige visibilidad de pago, un aspecto destacado o ambas cosas.",
  boost: "Boost",
  boostDetail: "Espacios patrocinados rotativos en búsquedas relevantes.",
  highlight: "Highlight",
  highlightDetail:
    "Un sutil marco verde destaca tu anuncio sin cambiar su posición.",
  bundle: "Destacar",
  bundleDetail: "Boost y Highlight durante siete días.",
  days: "{{count}} días",
  preview: "Vista previa de tu anuncio",
  previewNote: "Una muestra del aspecto, no una posición garantizada.",
  choose: "Elige una opción",
  continue: "Revisar promoción",
  notNow: "Ahora no",
  total: "Total",
  vat: "IVA incluido · pago único",
  saving: "Ahorra {{amount}} frente a la compra por separado",
  terms:
    "Empieza cuando el anuncio está aprobado y disponible. Se pausa si no está disponible y termina al venderse o retirarse.",
  consent:
    "Acepto las condiciones y solicito que comience cuando mi anuncio cumpla los requisitos.",
  pay: "Pagar {{amount}}",
  paying: "Procesando…",
  error: "Algo salió mal. Inténtalo de nuevo.",
  retry: "Reintentar",
  unavailable: "Las promociones no están disponibles para este anuncio ahora.",
  history: "Tus promociones",
  myAdsCta: "Promociones",
  processingPayment: "Procesando el pago",
  activeUntil: "Hasta el {{date}}",
  endedOn: "Finalizada el {{date}}",
  report: "Resultados de la campaña",
  impressions: "Impresiones visibles",
  clicks: "Clics",
  ctr: "Tasa de clics",
  noData: "Aún no hay datos",
  metricsNote:
    "Eventos registrados de la campaña, no personas únicas ni ventas adicionales. Debe verse la mitad de la tarjeta durante un segundo.",
  updated: "Actualizado: {{date}}",
  start: "Inicio",
  end: "Fin",
  withdraw: "Retirar promoción",
  withdrawConfirm: "¿Detener esta promoción?",
  withdrawNote:
    "La difusión se detiene inmediatamente. Cualquier reembolso se evalúa por separado y no está garantizado.",
  cancel: "Mantener promoción",
  confirm: "Detener y solicitar revisión",
  back: "Volver a mis anuncios",
  sponsored: "Patrocinado",
  advertiser: "Pagado por {{name}}",
  reason: "¿Por qué este anuncio?",
  processing:
    "Estamos verificando el pago con el servidor. Cerrar no cancela un pago completado.",
  refresh: "Actualizar estado",
  paymentConfirmed: "Pago confirmado",
  awaiting_payment: "Pendiente de pago",
  awaiting_listing: "Esperando tu anuncio",
  active: "Activa",
  paused: "Pausada",
  completed: "Finalizada",
  cancelled: "Cancelada",
  refund_required: "Requiere revisión",
  refunded: "Reembolsado",
  refund_requested: "Reembolso solicitado",
  pending: "Pendiente",
  paid: "Pagado",
  failed: "Fallido",
  payment: "Pago",
  noCampaign: "Aún no hay campañas. Tu primera promoción aparecerá aquí.",
  viewCampaign: "Ver campaña",
  checking: "Verificando disponibilidad…",
  expired: "Este presupuesto ha caducado. Actualízalo antes de pagar.",
  noGuarantee: "Sin garantía de posición, impresiones ni venta.",
  previewFixture:
    "Vista previa local · anuncio ficticio y datos de ejemplo · sin compra",
  daily: "Actividad diaria (UTC)",
  date: "Fecha",
  selected: "Seleccionado",
  viewTerms: "Leer condiciones",
  termsTitle: "Condiciones de promoción",
  termsBody:
    "Servicio publicitario de pago único. Los espacios patrocinados rotan entre anuncios relevantes; Highlight solo cambia el aspecto. La duración solo cuenta mientras se cumplan los requisitos. Retirar detiene la difusión e inicia una revisión humana del reembolso. Tus derechos legales no cambian.",
  entryTitle: "Ayuda a que tu pieza encuentre a sus compradores",
  entryBody:
    "Elige cómo destacar tu anuncio, en las búsquedas y en la página de inicio.",
  entryCta: "Ver opciones de promoción",
  editorTitle: "Promociona tu anuncio",
  stepChoose: "Elegir",
  stepReview: "Revisar",
  stepPayment: "Pago",
  boostBenefit: "Haz que te descubran",
  highlightBenefit: "Llama la atención",
  bundleBenefit: "Combina ambas ventajas",
  boostBody: "Espacios patrocinados en búsquedas relevantes.",
  highlightBody:
    "Dale a tu anuncio un marco verde distintivo en los resultados de búsqueda y las categorías.",
  bundleBody:
    "Visibilidad patrocinada y un marco verde, juntos durante siete días.",
  chooseDuration: "Elige la duración",
  previewOriginal: "Tu anuncio",
  previewPromoted: "Con tu promoción",
  selectionHint: "Elige una opción para continuar",
  reviewTitle: "Tu promoción, de un vistazo",
  startsWhenReady: "Empieza cuando tu anuncio esté aprobado y disponible",
  pausesWhenNeeded:
    "Se pausa mientras tu anuncio no esté disponible temporalmente",
  trackResults: "Consulta las impresiones y los clics en Mis anuncios",
  close: "Cerrar",
  changeOption: "Cambiar opción",
  fromPrice: "Desde {{amount}}",
  placementPreview: "Resultados patrocinados",
  appearancePreview: "Resultados de búsqueda",
  previewEmpty: "Así podría aparecer tu anuncio",
  oneTime: "Pago único",
  reportListing: "Tu anuncio",
  viewListing: "Ver anuncio",
  reportActivity: "Actividad de la promoción",
  reportAllTime: "Durante toda la promoción",
  reportShown: "Veces mostrado",
  reportShownHelp: "Tu anuncio promocionado estuvo visible en pantalla.",
  reportClicksHelp: "Clics en tu anuncio promocionado.",
  reportRateHelp: "Clics divididos entre las impresiones registradas.",
  reportChecked: "Informe consultado el {{date}}",
  reportDaily: "Actividad diaria",
  reportPeriod: "Periodo del informe",
  reportFullPeriod: "Todo el periodo",
  reportLastDays: "Últimos {{count}} días de actividad",
  reportRecordedDays:
    "Solo se muestran fechas con actividad registrada. Los días se agrupan en UTC.",
  reportDataTable: "Ver cifras diarias",
  reportNoActivity: "No hay actividad registrada",
  reportNoActivityBody:
    "Las impresiones y los clics registrados aparecerán aquí. Los totales de arriba muestran lo medido hasta ahora.",
  reportBeforeStart: "Tu informe comenzará cuando se active la promoción.",
  reportPurchase: "Tu promoción",
  reportIncluded: "Incluido en esta promoción",
  reportAmount: "Importe de compra",
  reportPurchased: "Pago recibido",
  reportReference: "Referencia de la campaña",
  reportScheduledEnd: "Fin previsto",
  reportFinishedOn: "Finalizada",
  reportSupport: "Contactar con atención al cliente",
  reportRefreshWarning:
    "No hemos podido actualizar este informe. Seguimos mostrando la última información disponible.",
  reportPollingStopped:
    "Seguimos esperando una actualización del pago. Las comprobaciones automáticas se han pausado; actualiza el estado para comprobarlo de nuevo.",
  reportResumeBody:
    "Continúa con el pago existente. Si ya has pagado, actualiza el estado antes de volver a intentarlo.",
  reportPendingBody:
    "El pago aún no está confirmado. Comprueba el pago original o la tienda de aplicaciones; no necesitas comprar otra promoción.",
  reportActiveTitle: "Tu promoción está activa",
  reportActiveBody:
    "Las ventajas elegidas están activas mientras tu anuncio esté disponible para los compradores.",
  reportWaitingTitle: "Lista cuando lo esté tu anuncio",
  reportWaitingBody:
    "El pago está confirmado. Tu promoción empieza cuando tu anuncio esté aprobado y disponible. El tiempo contratado aún no ha empezado.",
  reportPausedTitle: "Tu promoción está pausada",
  reportPausedBody:
    "Tu anuncio no está disponible temporalmente. La promoción se reanudará cuando vuelva a estarlo y se añadirá el tiempo de pausa.",
  reportHolidayBody:
    "La promoción está pausada mientras tu tienda está de vacaciones. Conservas el tiempo contratado hasta que tu anuncio vuelva a estar disponible.",
  reportReservedBody:
    "Tu anuncio está reservado. La promoción se pausa durante la reserva y conservas el tiempo contratado.",
  reportVerificationBody:
    "Estamos comprobando tu compra en la tienda de aplicaciones. La promoción está pausada y conservas el tiempo contratado. No necesitas volver a comprarla.",
  reportPlatformPauseBody:
    "Hemos pausado temporalmente las promociones. Conservas el tiempo contratado; no tienes que hacer nada.",
  reportApprovalBody:
    "Estamos revisando tu anuncio. La promoción empezará o se reanudará cuando esté aprobado y disponible; la espera no consume el tiempo contratado.",
  reportFinishedTitle: "Tu promoción ha terminado",
  reportFinishedBody:
    "El periodo contratado ha finalizado. El informe siguiente muestra la actividad registrada durante tu promoción.",
  reportSoldBody:
    "Tu artículo se ha vendido, por lo que la promoción ha terminado. La actividad siguiente corresponde a la promoción registrada y no demuestra que esta haya causado la venta.",
  reportWithdrawnBody:
    "Tu anuncio ya no está disponible, por lo que la promoción se ha detenido.",
  reportStoppedTitle: "La promoción se ha detenido",
  reportStoppedBody:
    "Esta promoción ya no está activa. La actividad registrada y los detalles de compra siguen disponibles abajo.",
  reportReviewTitle: "Tu promoción necesita una revisión",
  reportReviewBody:
    "La promoción se ha detenido mientras revisamos esta compra. Contacta con atención al cliente si necesitas ayuda; aún no se ha confirmado ningún reembolso.",
  reportWithdrawalBody:
    "Hemos recibido tu solicitud y la promoción se ha detenido. Cualquier reembolso se evalúa por separado.",
  reportRefundedTitle: "Pago reembolsado",
  reportRefundedBody:
    "Se ha confirmado un reembolso y esta promoción ya no está activa.",
  reportNotFound: "No hemos encontrado esta promoción en tu cuenta.",
  reportWithdrawalFailed:
    "No hemos podido confirmar tu solicitud. Esta ventana sigue abierta para que puedas volver a intentarlo. Consulta el estado de la campaña si tienes dudas.",
  reportRequestReview: "Solicitar una revisión",
  reportReviewConfirm: "¿Solicitar una revisión de esta promoción?",
  reportReviewNote:
    "La promoción ya ha terminado. Evaluaremos tu solicitud por separado; esto no garantiza un reembolso.",
  reportConfirmReview: "Enviar solicitud de revisión",
  reportEndedNoActivity:
    "No se registró actividad antes de que se detuviera esta promoción.",
  customPromotion: "Tu promoción",
  border: "Marco",
  label: "Etiqueta",
  homepage: "Espacio en la portada",
  fullBundle: "Pack Destaca",
  selectBundle: "Elegir Stand out",
  bundleIncludes: "Boost, Marco y Etiqueta durante 7 días",
  bundleSaving: "Ahorra {{amount}} frente a comprarlos por separado",
  bundleRecommendation:
    "Consigue 7 días de Boost, Marco y Etiqueta por {{amount}} — menos que esta selección.",
  borderBody: "Un marco verde para tu tarjeta.",
  labelBody: "Una etiqueta elegida por ti como vendedor.",
  homepageBody: "Tarjetas patrocinadas rotativas en el inicio.",
  homepageTerms:
    "Un espacio rotativo, no una posición exclusiva. Sin garantía de impresiones ni de venta.",
  homepageHeading: "Descubre más",
  homepageContext: "En la portada",
  homepagePreviewNote:
    "Tu tarjeta entra en una selección patrocinada rotativa. Esta vista previa no promete una posición fija.",
  labelChoose: "Elegir una etiqueta",
  labelMustGo: "Debe salir",
  labelMovingSale: "Venta por mudanza",
  labelInvoice: "Con factura original",
  labelCollect: "Listo para recoger",
  labelAttestation: "Confirmo que esta etiqueta es cierta para mi anuncio.",
  labelPaidNote:
    "Elegida y pagada por el vendedor. No es una verificación de Whoppah.",
  labelRequired:
    "Elige una etiqueta y confirma que es cierta antes de continuar.",
  none: "Ninguno",
  addBenefit: "Añadir {{benefit}}",
  removeBenefit: "Quitar {{benefit}}",
  selectionUnavailable:
    "Esta selección no está disponible ahora. Cambia tus opciones o vuelve a comprobar la disponibilidad.",
  effectUnavailable: "Ya activo o no disponible para este anuncio",
  homepageSoldOut:
    "Los espacios de portada están completos. Elige otras ventajas o vuelve a intentarlo más tarde.",
  checkAvailability: "Comprobar disponibilidad",
  mixedDurationNote:
    "Cada ventaja tiene su propia duración. El espacio en portada termina a los 3 días; las ventajas más largas continúan.",
  selectedBenefits: "Tus ventajas seleccionadas",
  benefitStatus: "Estado de cada ventaja",
  placementsTitle: "Dónde apareció tu promoción",
  placementSearch: "Resultados de búsqueda",
  placementCategory: "Resultados de categoría",
  placementCard: "Marco y etiqueta en tarjetas",
  placementHomepage: "Portada",
  placementLegacyHighlight: "Tarjetas destacadas",
  placementOther: "Otra ubicación",
  sharedExposureNote:
    "Una tarjeta puede incluir ventajas de varias compras. Los totales cuentan exposiciones registradas, no alcance único.",
  homepageCapacityWait:
    "Tu pago está confirmado. La promoción empezará cuando haya un espacio en portada y tu anuncio esté disponible. Tu tiempo pagado aún no ha empezado.",
  labelSuppressed:
    "Esta etiqueta se ha detenido para su revisión. Contacta con asistencia para obtener ayuda con tu compra.",
  newBenefits: "Añadir otras ventajas de promoción",
  previewSearch: "Tarjeta de búsqueda y categoría",
  previewHome: "Tarjeta de portada",
  benefitEnd: "Fin previsto de la ventaja",
  benefitStarts: "Inicio de la ventaja",
  historicalBundle: "Boost y Highlight",
  bundleV2Body: "Boost, un marco verde y tu etiqueta, juntos durante 7 días.",
  customPromotionBody: "Tus ventajas de promoción seleccionadas.",
  customPromotionBenefit: "Elige tus ventajas",
  placementPartial:
    "Faltan detalles de ubicación para parte de la actividad registrada. Esa actividad sigue incluida en los totales de tu campaña.",
  reportSomeActiveBody:
    "Al menos una ventaja está activa. Consulta abajo el estado y las fechas de cada ventaja.",
  homepageWaitReview:
    "No quedó libre ningún espacio en portada dentro del plazo de espera. Esta compra requiere una revisión de reembolso; aún no se ha confirmado ninguno.",
  chooseBenefits: "Crea tu promoción",
  selectionBenefitsHint: "Elige una o más opciones",
  termsBodyV2:
    "Este es un servicio publicitario de pago único. Los espacios en la página de inicio rotan. Marco y Etiqueta cambian el aspecto de la tarjeta; el vendedor elige y confirma las etiquetas, sin verificación de Whoppah. Cada opción dura el periodo comprado mientras el anuncio cumpla los requisitos. Una compra con espacio en la página de inicio comienza cuando hay un espacio y el anuncio está listo. La retirada detiene la difusión e inicia una revisión humana del reembolso. Tus derechos legales no cambian.",
  homepageStartFact:
    "Empieza cuando tu anuncio y un espacio en la página de inicio están disponibles",
  salesEyebrow: "HAZ QUE DESTAQUE",
  salesTitle: "El buen diseño merece ser visto.",
  salesBody: "Elige un paquete o crea el tuyo.",
  offerBoostBody: "Llega a compradores que buscan piezas como la tuya.",
  offerBundleBody:
    "Más visibilidad. Un aspecto distintivo. Todo en un paquete.",
  offerHomeTitle: "Stand out + portada",
  offerHomeBody:
    "Destaca en las búsquedas y capta la atención de quienes exploran la portada.",
  offerBoostCta: "Elegir Boost",
  offerHomeCta: "Elegir paquete",
  offerAllTogether: "Visibilidad + estilo",
  offerWiderReach: "Búsqueda + portada",
  offerSearchReach: "Visibilidad en búsquedas",
  offerRecommended: "Nuestra elección",
  offerMixedDuration: "Stand out 7 días · Inicio 3 días",
  offerSearchBenefit: "Espacios patrocinados en búsquedas relevantes",
  offerStyleBenefit: "Marco verde + etiqueta del vendedor",
  offerResultsBenefit: "Sigue las impresiones y los clics en Mis anuncios",
  offerBundleBenefit: "Boost + Marco + Etiqueta",
  offerHomeBenefit: "Espacio rotativo en la página de inicio",
  offerSelected: "Seleccionado",
  offerCustomize: "Elegir opciones individuales",
  offerMakeYours: "Tu vista previa",
  offerPreviewBody: "Revisa tu selección antes de pagar.",
  completionOptional:
    "La promoción es opcional. También puedes elegirla más tarde en Mis anuncios.",
  individualOptionsBody: "Elige una opción o combina.",
  individualLink: "Ver opciones individuales",
  standOutTitle: "Haz que tu anuncio destaque",
  standOutLead:
    "Elige una o varias opciones. Empieza cuando tu anuncio está publicado y disponible.",
  packDetail: "Boost de 7 días, marco y etiqueta juntos.",
  bestValue: "Mejor precio",
  percentOff: "{{percent}}% de descuento",
  orSeparately: "o elige por separado",
  boostPickerDetail:
    "Tu anuncio vuelve a lo más alto de su categoría. Empieza en cuanto tu anuncio esté publicado.",
  boostRunning:
    "Este anuncio ya tiene un boost activo. Podrás añadir un nuevo boost cuando termine.",
  framePickerDetail:
    "Un marco verde alrededor de tu anuncio en los resultados durante 7 días.",
  labelMustGoTitle: "Etiqueta «Debe salir»",
  previousPaymentProcessing:
    "Tu pago anterior todavía se está procesando. Inténtalo de nuevo dentro de un minuto.",
  labelPickerDetail: "Una etiqueta breve en tu anuncio durante 7 días.",
  homepagePickerDetail:
    "Un espacio patrocinado rotativo en la página de inicio durante 3 días.",
  searchPreviewTitle: "Así se ve tu anuncio en los resultados",
  searchPreviewLead:
    "Tu anuncio, con espacios grises que representan los anuncios cercanos.",
  promotedTab: "Promocionado",
  boostSummary: "Boost de {{count}} días",
  labelSummary: "Etiqueta «{{text}}»",
  nothingSelected: "Nada seleccionado",
  continueWithPrice: "Continuar al pago · {{price}}",
  goToMyAds: "Ir a mis anuncios",
  pricingContextChanged:
    "El descuento para anuncios nuevos ya no está disponible. Los precios se han actualizado.",
} as const;
